import { observer } from "mobx-react-lite";
import { Button, Center } from "@chakra-ui/react";
import { langStore, translate, useSelecting } from "@noli/business";
import SubEditorPanel from "@/components/SubPanel/SubEditor";
import { ImageBusinessOp } from "../components/ImageBusinessOp";

function GroupEditor() {
  const lang = langStore.tgt;
  const response = useSelecting("group");
  if (!response) {
    return null;
  }
  const { type, unGroup } = response;
  if (type !== "group") {
    return null;
  }
  return (
    <SubEditorPanel w="100%" panelTitle={translate("group-node-panel-title", lang)}>
      <Center w="100%" pl="24px" pr="24px" flexDirection="column" mt="12px" gap="24px">
        <Button w="100%" onClick={unGroup} variant="outline">
          {translate("ungrouping", lang)}
        </Button>
        <ImageBusinessOp />
      </Center>
    </SubEditorPanel>
  );
}

export default observer(GroupEditor);
